<template>
  <div class="h-screen flex w-full
        bg-img vx-row no-gutter
        justify-center padding_forget_password"
       id="page-init-password"
       >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div v-if="keyInitValid && !changePasswordSuccess">
            <div class="vx-row no-gutter justify-start bg-primary border-radius-default">
              <div class="vx-card__title pt-2">
                <h4 class="mb-2 pl-2 text-white">パスワード設定</h4>
              </div>
            </div>
            <div class="vx-row no-gutter justify-center items-center p-8 pt-0 login-tabs-container">
              <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg ">
                <div class="grid">
                  <vs-row class="mt-5 mb-3">
                    <strong>新しいパスワードを入力して[更新]ボタンをクリックしてください。</strong>
                  </vs-row>
                  <vs-row class="mt-5 mb-3">
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                      <label for="password">新しいパスワード <span class="color_red">*</span></label>
                    </vs-col>
                    <vs-col vs-type="flex" vs-align="center" vs-w="9">
                      <input id="password"
                                name="パスワードは"
                                class="inputx w-full" 
                                type="password"
                                placeholder="" 
                                v-model="password"
                                v-validate="'required|min:6'"
                                ref="password"/>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="9" vs-offset="3">
                      <span style="color: red">{{ errors.first("パスワードは") | convertError }}</span>
                      <div style="color: red" v-if="errorRegex && !errors.first('パスワードは')">{{ errorRegex }}</div>

                    </vs-col>
                  </vs-row>
                  <vs-row class="mt-5 mb-3">
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                      <label for="password-confirm">再入力 <span class="color_red">*</span></label>
                    </vs-col>
                    <vs-col vs-type="flex" vs-align="center" vs-w="9">
                      <input id="password-confirm"
                                name="確認パスワードは"
                                class="inputx w-full" 
                                type="password" 
                                placeholder=""
                                v-model="password_confirm"
                                v-validate="'required|confirmed:password|min:6'"/>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="9" vs-offset="3">
                      <span style="color: red">{{ errors.first("確認パスワードは") | convertError }}</span>
                      <div style="color: red" v-if="errorRegexConfirm && !errors.first('確認パスワードは')">{{ errorRegexConfirm }}</div>
                    </vs-col>
                  </vs-row>
                  </div>
                  <div class="grid">
                    <vs-row class="mt-2" vs-justify="space-between">
                      <vs-col vs-type="flex" vs-justify="flex-end">
                        <vs-button @click="submitRequest">更新</vs-button>
                        <router-link to="login" class="p-4 px-6">
                          閉じる
                        </router-link>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
            </div>
          </div>
          <div class="font-semibold" v-if="!keyInitValid && !$store.state.loading">
            <div class="vx-row no-gutter justify-start bg-primary border-radius-default">
              <div class="vx-card__title pt-2">
                <h4 class="mb-2 pl-2 text-white">登録完了</h4>
              </div>
            </div>
            <div class="grid">
              <div class="mb-3 mt-5">
                <vs-row vs-align="center" vs-justify="center">
                  <h2 class="center font-light"> {{ messageResponse }} </h2>   
                </vs-row>
              </div>
              <vs-row class="mt-5" vs-align="center" vs-justify="center">
                <router-link to="login" class="pb-4">
                  <vs-button>閉じる</vs-button>
                </router-link>
              </vs-row> 
            </div>
          </div>
          <div v-if="keyInitValid && changePasswordSuccess && !$store.state.loading">
            <div class="vx-row no-gutter justify-start bg-primary border-radius-default">
              <div class="vx-card__title pt-2">
                <h4 class="mb-2 pl-2 text-white">更新完了</h4>
              </div>
            </div>
            <div class="grid">
              <div class="mb-3 mt-5">
                <vs-row vs-align="center" vs-justify="center">
                  <h2 class="center font-light"> {{ messageResponse }} </h2>   
                </vs-row>
              </div>
              <vs-row class="mt-5" vs-align="center" vs-justify="center">
                <router-link to="login" class="pb-4">
                  <vs-button>閉じる</vs-button>
                </router-link>
              </vs-row> 
            </div>
          </div>
        </div>
      </vx-card>        
    </div> 
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      keyInitValid: false,
      messageResponse: "",
      password: "",
      errorRegex: null,
      errorRegexConfirm: null,
      password_confirm: "",
      token: "",
      changePasswordSuccess: false,
      regexFullWidth: /[ぁ-んァ-ン一-龥]/,
      regexTwoByteNumber: /[\uff10-\uff19\uff21-\uff3a\uff41-\uff5a]/,
    };
  },
  async created() {
    await this.isValidKeyInitPassword()
  },
  methods: {
    ...mapActions({
      checkKeyInitPassword: 'passwordModule/checkKeyInitPassword',
      changePasswordForget: 'passwordModule/changePasswordForgot',
    }),
    
    async isValidKeyInitPassword() {
      // const key = this.$route.query.key
      let key = this.$route.query.key
      if (key) {
        key = key.replaceAll(' ', '+')
        const response = await this.checkKeyInitPassword(key)
        if (response.status) {
          this.keyInitValid = true
          this.token = key
        } else {
          this.messageResponse = response.message;
        }
      }
    },
    async submitRequest() {
      let validateSuccess = false;
      await this.$validator.validateAll().then((result) => {
        if (result) {
          validateSuccess = true
        }
      })
      if (validateSuccess) {
        let params = {
          password: this.password,
          password_confirmation: this.password_confirm,
          token: this.token
        };
        const response = await this.changePasswordForget(params);
        if (response.status) {
          this.changePasswordSuccess = true
          this.messageResponse = response.message
        } else {
          this.keyInitValid = false
          this.messageResponse = response.message
        }
      }

      // console.log(response)
    },
  },
  watch: {
    password (val) {
      if (this.regexFullWidth.test(val)) {
        this.errorRegex = '全角文字で入力できません。'
      } else if (this.regexTwoByteNumber.test(val)) {
        this.errorRegex = '全角文字で入力できません。'
      } else {
        this.errorRegex = ''
      }
    },
    password_confirm (val) {
      if (this.regexFullWidth.test(val)) {
        this.errorRegexConfirm = '全角文字で入力できません。'
      } else if (this.regexTwoByteNumber.test(val)) {
        this.errorRegexConfirm = '全角文字で入力できません。'
      } else {
        this.errorRegexConfirm = ''
      }

    },
  },

  mounted() {},
};
</script>
<style scoped>
  #password, #password-confirm {
    height: 37px;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
  }
</style>